import type { ReactNode } from 'react';
import { Regions } from './Regions';

interface SectionProps {
  title: string;
  description: ReactNode;
}
function Section({ title, description }: SectionProps) {
  return (
    <div>
      <div className="text-sm font-bold">{title}</div>
      <div className="text-sm">{description}</div>
      <hr className="my-4" />
    </div>
  );
}

export default function Plan() {
  return (
    <div>
      <div className="mb-4 text-base">Your CivilGrid subscription includes the following</div>
      <Regions />

      <hr className="my-4" />

      <Section
        title="Unlimited Map Data"
        description="Access to ALL datasets and unlimited map access within your Region(s)."
      />

      <Section
        title="Projects"
        description="Create Projects for in-depth research and access to additional features."
      />

      <Section title="CivilSearch Map Request" description="Request additional maps from agencies through CivilGrid." />

      <Section
        title="CivilDraw"
        description="Prepare collaborative project sketches, plans, and notes with CivilGrid’s map-based drawing tools."
      />

      <Section
        title="Mobile App"
        description="Collect field notes, photos and videos, and pothole logs on the CivilGrid app to automatically sync your Quality Level C data across your CivilGrid org."
      />

      <Section
        title="Dedicated Support"
        description={
          <a
            href="mailto:support@civilgrid.com"
            rel="noreferrer noopener"
            className="text-blue-50 underline hover:text-blue-60"
          >
            support@civilgrid.com
          </a>
        }
      />
    </div>
  );
}
